var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1.73 0 501.73 335.247",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 498.304 0.413 L 1.877 0.413 L 1.877 331.37 L 498.304 331.37 L 498.304 0.413 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 498.304 73.413 L 1.877 73.413 L 1.877 114.785 L 498.304 114.785 L 498.304 73.413 Z",
    style: {
      fill: "rgb(216, 0, 39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 498.304 1.224 L 1.877 1.224 L 1.877 42.596 L 498.304 42.596 L 498.304 1.224 Z",
    style: {
      fill: "rgb(216, 0, 39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 498.304 145.603 L 1.877 145.603 L 1.877 186.974 L 498.304 186.974 L 498.304 145.603 Z",
    style: {
      fill: "rgb(216, 0, 39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 498.304 217.792 L 1.877 217.792 L 1.877 259.164 L 498.304 259.164 L 498.304 217.792 Z",
    style: {
      fill: "rgb(216, 0, 39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 498.304 289.98 L 1.877 289.98 L 1.877 331.353 L 498.304 331.353 L 498.304 289.98 Z",
    style: {
      fill: "rgb(216, 0, 39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 250.09 0.413 L 1.877 0.413 L 1.877 178.615 L 250.09 178.615 L 250.09 0.413 Z",
    style: {
      fill: "rgb(46, 82, 178)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 98.641 73.404 L 94.637 85.696 L 81.71 85.696 L 92.169 93.297 L 88.166 105.589 L 98.623 97.988 L 109.08 105.589 L 105.078 93.297 L 115.535 85.696 L 102.608 85.696 L 98.641 73.404 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 102.644 130.084 L 98.659 117.792 L 94.655 130.084 L 81.728 130.084 L 92.186 137.684 L 88.182 149.976 L 98.641 142.375 L 109.098 149.976 L 105.095 137.684 L 115.553 130.084 L 102.644 130.084 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 47.992 130.084 L 44.007 117.792 L 40.004 130.084 L 27.077 130.084 L 37.535 137.684 L 33.532 149.976 L 43.989 142.375 L 54.447 149.976 L 50.444 137.684 L 60.901 130.084 L 47.992 130.084 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 44.007 73.404 L 40.004 85.696 L 27.077 85.696 L 37.535 93.297 L 33.532 105.589 L 43.989 97.988 L 54.447 105.589 L 50.444 93.297 L 60.901 85.696 L 47.974 85.696 L 44.007 73.404 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 98.641 29.035 L 94.637 41.327 L 81.71 41.327 L 92.169 48.926 L 88.166 61.218 L 98.623 53.617 L 109.08 61.218 L 105.078 48.926 L 115.535 41.327 L 102.608 41.327 L 98.641 29.035 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 44.007 29.035 L 40.004 41.327 L 27.077 41.327 L 37.535 48.926 L 33.532 61.218 L 43.989 53.617 L 54.447 61.218 L 50.444 48.926 L 60.901 41.327 L 47.974 41.327 L 44.007 29.035 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 153.291 73.404 L 149.288 85.696 L 136.362 85.696 L 146.819 93.297 L 142.816 105.589 L 153.274 97.988 L 163.731 105.589 L 159.728 93.297 L 170.186 85.696 L 157.259 85.696 L 153.291 73.404 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 157.277 130.084 L 153.291 117.792 L 149.288 130.084 L 136.362 130.084 L 146.819 137.684 L 142.816 149.976 L 153.274 142.375 L 163.731 149.976 L 159.728 137.684 L 170.186 130.084 L 157.277 130.084 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 211.946 130.084 L 207.96 117.792 L 203.957 130.084 L 191.03 130.084 L 201.489 137.684 L 197.485 149.976 L 207.943 142.375 L 218.4 149.976 L 214.397 137.684 L 224.855 130.084 L 211.946 130.084 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 207.943 73.404 L 203.939 85.696 L 191.013 85.696 L 201.471 93.297 L 197.467 105.589 L 207.925 97.988 L 218.383 105.589 L 214.38 93.297 L 224.837 85.696 L 211.911 85.696 L 207.943 73.404 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 153.291 29.035 L 149.288 41.327 L 136.362 41.327 L 146.819 48.926 L 142.816 61.218 L 153.274 53.617 L 163.731 61.218 L 159.728 48.926 L 170.186 41.327 L 157.259 41.327 L 153.291 29.035 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 207.943 29.035 L 203.939 41.327 L 191.013 41.327 L 201.471 48.926 L 197.467 61.218 L 207.925 53.617 L 218.383 61.218 L 214.38 48.926 L 224.837 41.327 L 211.911 41.327 L 207.943 29.035 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.2e5351347438e285ebe935c183da22b3.svg";
export { ForwardRef as ReactComponent };